// Convertit un emoji drapeau (ex "🇫🇷") ou un code ISO2 (ex "fr") en URL d'image réelle (flagcdn).
// Les emojis drapeaux ne s'affichent pas sous Windows (rendus "FR", "GB"...) -> on force une vraie image.
export function flagUrl(input, size = "w40") {
  if (!input) return null;
  let code = null;
  const cps = [...input].map((c) => c.codePointAt(0));
  const letters = cps
    .filter((cp) => cp >= 0x1f1e6 && cp <= 0x1f1ff)
    .map((cp) => String.fromCharCode(cp - 0x1f1e6 + 65));
  if (letters.length >= 2) {
    code = letters.join("").toLowerCase();
  } else if (/^[a-zA-Z]{2}$/.test(input.trim())) {
    code = input.trim().toLowerCase();
  }
  if (!code) return null;
  return `https://flagcdn.com/${size}/${code}.png`;
}
